<template>
  <div class="main-header">
    <div class="menu-button" @click="toggleMenu">
      <template v-if="!menuOpen">
        <img src="@/assets/MenuButton.svg"/>
        <NotificationsBadge class="notifications-badge" small :counter="this.$store.getters.unreadNotifications.all"/>
      </template>
      <CloseIcon v-else class="close-btn" :size="32"/>
    </div>
    <img class="logo" @click="toDashboard" src="@/assets/HeaderLogo.svg"/>
    <div :key="servedBy" v-if="servedBy == 'mercury.perfecthome.no'" style="background-color: red;color:white;">DEV</div>
    <div class="search-button">


        <img src="@/assets/SearchButton.svg"/>
      </div>
    </div>
    <div @click="closeForm" class="add-entity-form-wrapper" id="add-entity-form-wrapper" v-if="overlayPageOpen">
      <CustomerForm v-if="formBuilder.entityType === 'customer' && formBuilder.formOpen"
                    :reference="formBuilder.entityReference" @customer-submitted="addCustomer" @form-closed="closeForm"
                    @add-component-clicked="()=>{ $emit('add-component-clicked', 'customer') }"/>
      <PartyForm v-if="formBuilder.entityType === 'party'" :preselectedDate="formBuilder.preselectedDate"
                 :preselectedHost="formBuilder.preselectedHost" :reference="formBuilder.entityReference"
                 @party-submitted="addParty" @form-closed="closeForm" @add-component-clicked="addCustClicked"/>
      <ParticipantForm v-if="formBuilder.entityType === 'participant'" :reference="formBuilder.entityReference"
                       @form-closed="closeForm"
                       @add-component-clicked="()=>{ $emit('add-component-clicked', 'customer') }"
                       v-show="canShowParticipantForm"
      />
      <OrderListForm v-if="formBuilder.entityType === 'orderlist'" :for_linetype="1"
                     :reference="formBuilder.entityReference" @form-closed="closeForm"/>
      <FocusProductForm v-if="formBuilder.entityType === 'focusproduct'" :reference="formBuilder.entityReference"
                        @form-closed="closeForm"/>
      <PartyListForm v-if="formBuilder.entityType === 'partylist'" :reference="formBuilder.entityReference"
                     @form-closed="closeForm"/>
      <DirectSaleForm v-if="formBuilder.entityType === 'direct'" :reference="formBuilder.entityReference"
                      @form-closed="closeForm"
                      @add-component-clicked="()=>{ $emit('add-component-clicked', 'customer') }"
                      v-show="canShowParticipantForm"
      />
      <DirectSaleForm v-if="formBuilder.entityType === 'direct'" :reference="formBuilder.entityReference"
                      @form-closed="closeForm"
                      @add-component-clicked="()=>{ $emit('add-component-clicked', 'customer') }"
                      v-show="canShowParticipantForm"
      />
      <ReplacementProductForm v-if="formBuilder.entityType === 'replacement-sku'"
                              :reference="formBuilder.entityReference"
                              @form-closed="closeForm"


      />
      <SmsForm v-if="$store.state.customers.messages.popupOpen"/>
      <MergeForm v-if="$store.state.customers.merge.popupOpen" @form-closed="closeForm"/>
      <AddressForm v-if="formBuilder.entityType === 'address'"
                   @form-closed="closeForm"
                   @address-submitted="submitNewAddress"
      />
      <TagPicker v-if="$store.state.customers.filters.filterPageOpen"/>
    </div>
    <HeaderMenu/>
</template>

<script>
import NotificationsBadge from '@/components/core/NotificationsBadge.vue'
import CloseIcon from '@/components/core/CloseColorable.vue'


import * as types from '@/store/mutations';
import {toRef, getCurrentInstance} from 'vue';
import {useRouter} from 'vue-router';
import {useStore} from 'vuex';
import HeaderMenu from "./HeaderMenu";
import CustomerForm from '../forms/CustomerForm';
import PartyForm from '../forms/PartyForm';
import ParticipantForm from '../forms/ParticipantForm';
import DirectSaleForm from '../forms/DirectSaleForm';
import OrderListForm from '../forms/OrderListForm';
import PartyListForm from '../forms/PartyListForm';
import MergeForm from '@/components/forms/merge/MergeForm.vue';
import SmsForm from '@/components/forms/SmsForm';
import TagPicker from '../forms/TagPicker';
import FocusProductForm from "../forms/FocusProductForm";
import ReplacementProductForm from "@/components/forms/ReplacementProductForm";
import AddressForm from "@/components/forms/AddressForm.vue";

export default {
  name: "HeaderSection",
  components: {
    AddressForm,
    ReplacementProductForm,
    FocusProductForm,
    HeaderMenu,
    CustomerForm,
    PartyForm,
    ParticipantForm,
    OrderListForm,
    PartyListForm,
    TagPicker,
    DirectSaleForm,
    MergeForm,
    SmsForm,

    NotificationsBadge,
    CloseIcon
  },
  props: {
    formBuilder: {
      formOpen: false,
      entityType: '',
      entityReference: -1,
      preselectedDate: new Date(),
      lineType: 1
    }
  },
  watch: {
    overlayPageOpen: {
      handler(value) {
        this.$store.commit(types.UPDATE_OVERLAY_ACTIVE, value)
      },
      immediate: true
    }
  },
  computed: {
    menuOpen() {
      return this.$store.state.system.menuOpen
    },
    servedBy() {
      return this.$store.getters.servedBy
    },
    overlayPageOpen() {
      if (this.formBuilder.formOpen) {
        return true
      }
      if (this.$store.state.customers.filters.filterPageOpen) {
        return true
      }
      if (this.$store.state.customers.merge.popupOpen) {
        return true
      }
      if (this.$store.state.customers.messages.popupOpen) {
        return true
      }
      if (this.$store.state.system.customPopupOpen) {
        return true
      }
      return false
    },
    canShowParticipantForm() {
      if (this.$store.state.customers.filters.filterPageOpen) {
        return false
      }
      return true
    }
  },
  emits: ['close-form', 'add-component-clicked', 'update-calendar'],
  methods: {
    /* eslint-disable-next-line no-unused-vars */
    closeForm(e) {
      this.$emit('close-form')
    },
    addCustClicked() {
      this.$emit('add-component-clicked', 'customer')
    },
    toggleMenu() {
      this.$store.commit(types.TOGGLE_MENU)
    },
    closeMenu() {
      this.$store.commit(types.CLOSE_MENU)
    }
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const formBuilder = toRef(props, 'formBuilder')
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;


    const addCustomer = customerSubmission => {
      store.dispatch("addCustomer", customerSubmission.customer).then(async res => {
        formBuilder.value.formOpen = false
        emitter.emit("customer_updated", res)

        const createdCustomerId = res.id
        const shouldAddCreatedCustomerAsParticipantToCurrentParty = (router.currentRoute.value.name === 'PartyView')
        const currentPartyId = router.currentRoute.value.params?.id

        if (!shouldAddCreatedCustomerAsParticipantToCurrentParty) {
          formBuilder.value.formOpen = false
        }

        if (shouldAddCreatedCustomerAsParticipantToCurrentParty && currentPartyId) {
          try {
            store.commit(types.START_ADDING_PARTICIPANT, createdCustomerId)
            await store.dispatch('addParticipant', {personId: createdCustomerId, partyId: currentPartyId})
            await store.dispatch('loadParty', currentPartyId)
            formBuilder.value.formOpen = false
            store.commit(types.DONE_ADDING_PARTICIPANT, createdCustomerId)
          } catch (err) {
            console.log(err)
          }
        } else {
          //console.log("Forwarding to detail view for new customer");
          if (customerSubmission.redirect === true) {
            formBuilder.value.formOpen = true
            formBuilder.value.entityType = 'party'
            formBuilder.value.preselectedDate = customerSubmission.date
            formBuilder.value.preselectedHost = res.id
          } else {
            await router.push({name: 'Customers', params: {id: res.id}})
          }

        }
      })
    }

    const addParty = (party) => {
      store.dispatch("addParty", party).then((res) => {
        let id = res.id
        let payload = party
        store.dispatch("saveParty", {payload, id}).then((res) => {
          store.dispatch('getCalendar').then(() => {
            formBuilder.value.formOpen = false
            formBuilder.value.preselectedHost = -1
            formBuilder.value.entityReference = -1
            window.scrollTo(0, 0);
            router.push({name: 'PartyView', params: {id: res.id}});
            //console.log(res);
            emitter.emit('update-calendar')
          })
        })
      })
    }
    const toDashboard = () => {
      window.scrollTo(0, 0)
      router.push({name: 'FrontPage'})

    }

    const submitNewAddress = (addressData) => {
      store.dispatch('addAddress', addressData).then((r) => {
        formBuilder.value.formOpen = false
        console.log('add new address response :', r);
      }).catch((e) => {
        console.log('all addresses Error:' + e)
      })

    }

    return {
      addCustomer,
      addParty,
      toDashboard,
      submitNewAddress
    }
  }
}
</script>
